export default {
  title: {
    en: 'Shop the Edit',
  },
  text: {
    en: `
      Immerse yourself in scent beyond<br />
      the bottle with candles, body<br />
      lotions, diffusers, and so much<br />
      more.
    `,
  },
}
